import React from 'react'
import { ResortItem } from '../../Resorts'

type ResortItemProps = {
    id?: number;
    image: string;
    link: string;
    short_description: string;
    title: string;
}

const ResortItem = ({image,link,short_description,title}: ResortItemProps) => {
  return (
    <div className='resortItem'>
        <a target='_blank' href={link}>
            <img src={`${image}`} />
        </a>
        <div className='resortItem__title'><a target='_blank' href={link}>{title}</a></div>
        <div className='resortItem__sd'><a target='_blank' href={link}>{short_description}</a></div>
    </div>
  )
}

export default ResortItem